import CboardLogo from './CboardLogo.component';

export default CboardLogo;
